export var GithubAuditEngineOperator;
(function (GithubAuditEngineOperator) {
    GithubAuditEngineOperator["IN"] = "IN";
})(GithubAuditEngineOperator || (GithubAuditEngineOperator = {}));
export var GithubAuditEngine;
(function (GithubAuditEngine) {
    GithubAuditEngine["GENERIC"] = "GENERIC";
    GithubAuditEngine["COMPARE"] = "COMPARE";
    GithubAuditEngine["CHECKATTR"] = "CHECKATTR";
})(GithubAuditEngine || (GithubAuditEngine = {}));
;
